import React, { useEffect, useState } from 'react';
import { LayoutContainer } from 'pages/layout/Layout.style';
import Sidebar from 'pages/sidebar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Headers from 'pages/layout/Header';
import Suggestions from 'pages/home/Suggestions';
import Footer from './Footer';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useCapacitorBackButton from 'components/HandleSlideBack';
import DynModel from 'components/Modal';
import AboutUs from 'pages/privacy/AboutUs';
import PrivacyPolicy from 'pages/privacy/PrivacyPolicy';
import TermsAndCondition from 'pages/privacy/TermsAndCondition';
import { initSocket } from 'components/Socket';
import { useDispatch } from 'react-redux';
import { handleUpdateNotificationCount } from 'redux/features/NotificationSlice';
import ScrollToTopButton from 'components/ScrollToTop';

const paths = ['/settings', '/network', '/business-hub'];
const exactPaths = ['/jobs', '/businessplace', '/jobs/applied-list'];
const sideNavPaths = ['/jobs/applied-list'];

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState({});

  useCapacitorBackButton();

  useEffect(() => {
    const socket = initSocket();

    socket.on('connect', () => {
      // console.log('Connected as:', socket.id);
      socket.emit('notificationCount');
    });

    socket.on('notificationCount', (count) => {
      dispatch(handleUpdateNotificationCount(count));
      count && setNotificationCount(count);
    });

    return () => {
      socket.off('connect');
      socket.off('notificationCount');
      socket.disconnect();
    };
  }, []);

  const navPath = !(
    paths.find((li) => pathname.startsWith(li)) ||
    exactPaths.find((li) => pathname === li)
  );

  const hideSideNav = !sideNavPaths.find((li) => pathname === li);

  return (
    <>
      <Headers notificationCount={notificationCount} />
      <LayoutContainer
        className="LayoutContainer"
        isshowaside={navPath ? navPath.toString() : undefined}
      >
        <div className="layout-wrapper">
          <div className={clsx(hideSideNav && 'layout-sub-wrapper')}>
            {hideSideNav && (
              <div className="sidebar fixed-sidebar">
                <Sidebar notificationCount={notificationCount} />
              </div>
            )}
            <main className="content">
              <Outlet />
              {children}
            </main>
            {navPath && (
              <aside>
                <div className="aside-container">
                  <Suggestions />
                  <div className="policy-container">
                    <div onClick={() => setIsModalOpen('about')}>
                      {t(`HomePage.AboutUs`)}
                    </div>
                    <div onClick={() => setIsModalOpen('privacy')}>
                      {t(`HomePage.PrivacyPolicy`)}
                    </div>
                    <div onClick={() => setIsModalOpen('terms')}>
                      {t(`HomePage.Terms`)}
                    </div>
                    <div onClick={() => navigate('/blog')}>
                      {t('HomePage.Blog')}
                    </div>
                  </div>
                </div>
              </aside>
            )}
          </div>
          <DynModel
            modalchanges="privacyModal"
            openModal={isModalOpen}
            modelTitle={
              isModalOpen === 'about'
                ? 'About Us'
                : isModalOpen === 'privacy'
                ? 'Privacy Policy'
                : isModalOpen === 'terms' && 'Terms & Condition'
            }
            handleCancelModal={() => setIsModalOpen(false)}
            content={
              isModalOpen === 'about' ? (
                <AboutUs hideBackArrow />
              ) : isModalOpen === 'privacy' ? (
                <PrivacyPolicy hideBackArrow />
              ) : (
                isModalOpen === 'terms' && <TermsAndCondition hideBackArrow />
              )
            }
          />
        </div>
      </LayoutContainer>
      <Footer />
      <ScrollToTopButton />
    </>
  );
};
export default Layout;
